import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import topic from 'dojo/topic';

import '../../../../moreCore/UI/GenericDialog/GenericDialog';
import _EntityViewMixin from '../../../../moreCore/UI/EntityBased/EntityView/EntityView';
import { VAM2types, VAMclassNames } from "../../../_loadingHelpers/VAMv2Types";

import TravelBookingForm from "./TravelBookingForm";
import { ProjectRef, TravelBookingListData } from "../TravelBookingListTypes";
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import _WidgetBase from 'dijit/_WidgetBase';

class TravelBookingView extends compose(_EntityViewMixin<TravelBookingListData>) {
    //templateString = template;

    //private entityID: string = null;
    //private entity: VAMtypes.EvBookingEntity_Short = null;
    //private dlg: GenericDialog = null;
    private _loadingRequest: dojo.request.Promise<any> = null;
    private editingVisible: boolean = false;

    private actionNode: HTMLElement;
    private contentNode: HTMLElement;
    private btnDelete: HTMLButtonElement;

    private _additionalRequestParams: Object = null;

    private _openEditor: () => MdsLax<InstanceType<typeof _WidgetBase>> = null;

    private project: VAM2types.EvProjectEntity_Extended;
    private tempEntity: TravelBookingListData;


    /**
     *
     * @param entityId
     * @param label
     * @param additionalParams
     * @param tabContainerName
     * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
     */
    setup(entityId: string,
        label: string,
        entity?: TravelBookingListData,
        project?: VAM2types.EvProjectEntity_Extended,
        openTravelBookingForm?: () => MdsLax<InstanceType<typeof _WidgetBase>>,
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string,

    ) {

        this.project = project;
        this.tempEntity = entity;
        this.tabContainerName = tabContainerName;
        if (openTravelBookingForm) this._openEditor = openTravelBookingForm;;

        if (additionalParams) {
            this.config.additionalRequestParams = lang.clone(additionalParams);
        }

        if (contextName) this.setContextName(contextName);

        this.showAsDlg(entityId, label, tabContainerName);
    }





    onShow() {
        this.handleAdditionalButtons();

    }

    private handleAdditionalButtons() {
        if (this.hasUserRole("Travel_Delete")) {
            this.addButton("deleteButton", this.translate("General_Delete"), lang.hitch(this, this._onClickDelete), null, null, "fas fa-trash warningTXT icon", null, "left last");
        }

        if (this.tempEntity){
            if ((this.tempEntity.Classname === "transfer_bookings" ||
                this.tempEntity.Classname === "transport_booking" ||
                this.tempEntity.Classname === "train_bookings" ||
                this.tempEntity.Classname === "flight_bookings" ||
                this.tempEntity.Classname === "travel_info_booking")
                && this.hasUserRole("Travel_Create")) {

                this.addButtonMenu("copy", this.translate("General_Label_Copy"), "fas fa-copy", true);

                //this.addButton("copy", "test", null, null, "fas fa-copy", null, false, "left last", true, true, false, "copy");

                this.addButton("locationSwitched",
                    this.translate("TravelBookingForm_Label_CopyLocation"),
                    lang.hitch(this, this._onClickCopy, "ReverseLocation"),
                    this.translate("TravelBookingForm_Tooltip_ReverseLocation"),
                    null,
                    "fas fa-repeat",
                    null,
                    "left last",
                    true,
                    false,
                    true,
                    "copy"
                );

                this.addButton("location",
                    this.translate("TravelBookingForm_Label_CopyLocation"),
                    lang.hitch(this, this._onClickCopy, "SaveLocation"),
                    this.translate("TravelBookingForm_Tooltip_SaveLocation"),
                    null,
                    "fas fa-copy",
                    null,
                    "left last",
                    true,
                    false,
                    true,
                    "copy"
                );

                this.addButton("noLocation",
                    this.translate("TravelBookingForm_Label_CopyLocation"),
                    lang.hitch(this, this._onClickCopy, ""),
                    this.translate("TravelBookingForm_Tooltip_NoLocation"),
                    null,
                    "fas fa-trash warningTXT",
                    null,
                    "left last",
                    true,
                    false,
                    true,
                    "copy"
                );
            }
        }

    }

    private _onClickCopy(mode: "ReverseLocation" | "SaveLocation" | "", e: MouseEvent) {
        this.StandbyStart();

        let payload = {
            ID: this.tempEntity.ID,
            Classname: this.tempEntity.Classname,
            mode: mode
        }

        this.RequestManager.callfunction("Webtool_API__TravelBookingForm_CopyTransferBooking", payload, lang.hitch(this, this._onCopyResponse), lang.hitch(this, this._onCopyError))
    }

    private _onCopyResponse(response) {
        this.StandbyStop();
        this.emit("save");
        this.showToast(this.translate("TravelBookingForm_Success_Copy"), "fas fa-check");
    }

    private _onCopyError(error) {
        this.StandbyStop();
        console.error(error);
        this.showToast(this.translate("TravelBookingForm_Error_Copy"), "fas fa-exclamation-triangle");
    }

    protected onRequestEditor(entityID: string): MdsLax<InstanceType<typeof _WidgetBase>> {
        if (!this._openEditor) {
            let classname = this.entity.Classname;

            let editor = new TravelBookingForm(classname);
            editor.setupForm(false, classname, this.entity.ref_ev_project as any, entityID);

            let isNew = false;
            let bookingType = classname;
            let label = this.entity.gDisp_1;
            let id = entityID;


            if (this.getTabContainer()) {

                let tabConfig: Tabbing.TabPageDescriptor = {
                    targetContainerName: this.getContainerName(),
                    enableClosing: true,
                    label: label,
                    name: id ? id : "_blank",
                    widget: editor,
                    groupLabel: label,
                };
                this.requestNewTabbedContent(tabConfig, true);
                this.requestTabswitch(tabConfig.name);
            } else {
                var dlg = new GenericDialog();
                dlg.keepOpen = true;
                dlg.show(editor, label, null);
                dlg._setOkBtnAttr(false);
                dlg.addButton("save", this.translate("General_Save"), lang.hitch(editor, editor._onSaveButtonClick), null, "accentBG", "fas fa-save", false, "first");
                dlg.addButton("close", this.translate("General_Close"), lang.hitch(editor, this._onDlgClose, editor, dlg));
                dlg.disableButton("save");
                editor.on("dirty", lang.hitch(dlg, dlg.enableButton, "save"));
                editor.on("close", lang.hitch(dlg, dlg.close));
            }
            editor.startup();

            return editor;

        } else {
            return this._openEditor();
        }

        //let editor = new TravelBookingForm(this.tempEntity.Classname);
        //editor.setupForm(false, this.tempEntity.Classname, this.project);

        ////editor.startup();
        ////if (!this.isEmbeddedInTab) this.tryMoveToTab();

        //// versuchen: Tab öffnen
        //if (this.createNewTabbedContent({
        //    enableClosing: true,
        //    name: entityID,
        //    sidebarEntryName: entityID,
        //    label: editor.getTabTitle(),
        //    widget: editor,
        //    groupLabel: this.tempEntity.ClassPrintname,
        //    targetContainerName: this.tabContainerName
        //}, true, true) == true) {
        //    // Tab öffnen hat funktioniert
        //} else {
        //    let dlg = new GenericDialog();
        //    dlg.closeOnEnter = false;
        //    dlg.closeOnEscape = false;
        //    dlg._setTopCloseBtnAttr(true);
        //    dlg.keepOpen = true;
        //    //dlg.setUserdefinedButton(this.translations["AddressWizard__done"],
        //    //    null,
        //    //    lang.hitch(this, this._onWizardDone, dlg, this.editor))


        //    //dlg.enableContentOverflow(true);

        //    dlg.show(editor,
        //        this.title,
        //        null,
        //        null,
        //        "saveclose",
        //        lang.hitch(this, this._onDlgCallback, dlg, editor));
        //}

        //editor.loadData(entityID, this.tempEntity.Classname);



        //editor.on("save", lang.hitch(this, this.emit, "save"));
        //editor.on("deleted", lang.hitch(this, this.emit, "deleted"))
        //editor.on("close", lang.hitch(this, this.emit, "close"));
        //editor.on("newBookingForm", lang.hitch(this, this.emit, "newBookingForm"));

        //editor.startup();
    }

    private _onDlgClose(form: MdsLax<InstanceType<typeof TravelBookingForm>>, dlg: MdsLax<InstanceType<typeof GenericDialog>>) {
        var isClosed = form._onCloseRequest();
        if (isClosed) {
            dlg.close();
        }
    }

    private _onClickDelete(e: Event): void {
        var deleteCollectorRefs: boolean = false;

        if (this.tempEntity.Classname === "flight_booking_collection" ||
            this.tempEntity.Classname === "travel_booking_collection" ||
            this.tempEntity.Classname === "vt_travel_collection") {
            if (this.tempEntity.EL_vt_travel_travel_booking_collector) {
                let dlgConfirm = new GenericDialog();
                dlgConfirm.show(
                    this.translate("TravelBookingForm_ConfirmDeleteCollector"),
                    this.translate("General_Delete"),
                    "",
                    "fas fa-trash warningTXT icon",
                    "yesno",
                    lang.hitch(this, this._deleteCollectionRefsCallback, deleteCollectorRefs)
                );
            } else {
                this._deleteTravelBooking();
            }
        } else {
            this._deleteTravelBooking();
        }
    }


    private _deleteTravelBooking(deleteCollectorRefs?: boolean) {
        if (this.tempEntity.EL_vt_travel_travel_booking_collector) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(
                this.translate("General_ConfirmDeleteMessage"),
                this.translate("General_Delete"),
                "",
                "fas fa-trash warningTXT icon",
                "okcancel",
                lang.hitch(this, this._confirmDeleteCallback, deleteCollectorRefs)
            );
        } else {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(
                //TravelBookingForm_ConfirmDeleteRelatedAddress
                this.translate("TravelBookingForm_ConfirmDeleteRelatedAddress"),
                this.translate("General_Delete"),
                "",
                "fas fa-trash warningTXT icon",
                "okcancel",
                lang.hitch(this, this._confirmDeleteCallback, deleteCollectorRefs)
            );
        }
    }


    private _deleteCollectionRefsCallback(deleteCollectionsRefs: boolean, response: number): void {
        if (response === 2) {
            deleteCollectionsRefs = true;
        }

        this._deleteTravelBooking(deleteCollectionsRefs);
    }

    private _confirmDeleteCallback(deleteCollectorRefs: boolean, response: number): void {
        if (response === 1) {
            this.RequestManager.callfunction("Webtool_API_TravelBookingForm_Delete",
                { ID: this.tempEntity.ID, type: this.tempEntity.Classname, deleteCollectorRefs: deleteCollectorRefs },
                lang.hitch(this, this._onResponseDelete),
                lang.hitch(this, this._onErrorDelete));
        }
    }

    _onResponseDelete(response) {
        this.emit("deleted");
        this.close();
    }

    _onErrorDelete(error) {
        console.error(error);
    }


    afterDelete() {
        topic.publish("EvBooking/Deleted", this.entity);
    }



    postCreate(): void {



        this.config = {
            entityClassname: VAMclassNames.vt_travel,
            labelProperty: "ev_booking_name",
            entityClassPrintname: this.translate("General_Label_EvBooking"),
            editOptions: {
                userroleEdit: "Travel_Edit",
                featurePathEdit: null,//"EvBooking/EvBookingEditor",
                onChangedEventName: "change",
                onDeletedEventName: "deleted",
                onSavedEventName: "saved"
                
            }            
            //requestDataFunctionname:"Webtool_API_Appointments__GetEntityData"
        }
        super.postCreate.apply(this, arguments as any);


        //    this.checkPrivileges();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);


    }
}

export default mdsWidget(TravelBookingView);
